import {
  ToggleButton,
  ToggleButtonGroup,
  Box,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import WindPowerIcon from "@mui/icons-material/WindPower";
import ForestIcon from "@mui/icons-material/Forest";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import React from "react";

const Filters = ({ filters, setFilters }) => {
  return (
    <Box display="flex" justifyContent="start" alignItems="center">
      <ToggleButtonGroup
        value={filters.fuelType}
        exclusive
        onChange={(e, value) => {
          setFilters(() => ({ ...filters, fuelType: value }));
        }}
        aria-label="fuel type"
      >
        <ToggleButton value="solar" aria-label="solar">
          <LightModeIcon />
        </ToggleButton>
        <ToggleButton value="wind" aria-label="wind">
          <WindPowerIcon />
        </ToggleButton>
        <ToggleButton value="biomass" aria-label="biomass">
          <ForestIcon />
        </ToggleButton>
        <ToggleButton value="other" aria-label="other">
          <MoreHorizIcon />
        </ToggleButton>
      </ToggleButtonGroup>
      <ToggleButtonGroup
        value={filters.country}
        exclusive
        onChange={(e) =>
          setFilters(() => ({ ...filters, country: e.target.value }))
        }
        aria-label="country"
        sx={{ ml: 2 }}
      >
        <ToggleButton value="EE" aria-label="ee" sx={{ p: "0.6rem 1rem" }}>
          EE
        </ToggleButton>
        <ToggleButton value="LV" aria-label="lv" sx={{ p: "0.6rem 1rem" }}>
          LV
        </ToggleButton>
        <ToggleButton value="LT" aria-label="lt" sx={{ p: "0.6rem 1rem" }}>
          LT
        </ToggleButton>
      </ToggleButtonGroup>
      <FormControl sx={{ ml: 2, minWidth: 180 }} size="small">
        <InputLabel>Production support</InputLabel>
        <Select
          value={filters.productionSupport}
          label="Production support"
          onChange={(e) =>
            setFilters(() => ({
              ...filters,
              productionSupport: e.target.value,
            }))
          }
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
      <FormControl sx={{ ml: 2, minWidth: 180 }} size="small">
        <InputLabel>Investment support</InputLabel>
        <Select
          value={filters.investmentSupport}
          label="Investment support"
          onChange={(e) =>
            setFilters(() => ({
              ...filters,
              investmentSupport: e.target.value,
            }))
          }
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
      <FormControlLabel
        control={
          <Switch
            checked={filters.filterByGroups}
            onChange={(e) =>
              setFilters(() => ({
                ...filters,
                filterByGroups: e.target.checked,
              }))
            }
          />
        }
        label="Filter by groups"
        sx={{ ml: 1 }}
      />
    </Box>
  );
};

export default Filters;
